class SpacesController

  @toggleAmountInput: ->
    checkbox = $('#space_state_change_request_charge_normal_amount')[0]
    amount_field = $('#space_state_change_request_amount')[0]

    return unless checkbox

    if checkbox.checked
      amount_field.disabled = true
    else
      amount_field.disabled = false

$(document).ready ->
  $(document).on('change', '#space_state_change_request_charge_normal_amount', (event) ->
    SpacesController.toggleAmountInput()
  )
  SpacesController.toggleAmountInput()

module.exports = SpacesController
